import { styled } from 'styled-components';

/**
 * The main element of the page, which is an iframe that renders the chatbot
 */
export const Iframe = styled.iframe`
  border: none;
  height: 100%;
  width: 100%;
`;
